import {
  ICreateOrderCompletedAction,
  IFetchOrderDetailsCompletedAction,
  IFetchOrderDetailsFailedAction,
  IFetchOrderDetailsStartedAction,
  IMoveOrderRoFolderCompletedAction,
  IUpdateOrderCompletedAction,
  ORDER_DETAILS_FETCH_STARTED,
  ORDER_DETAILS_FETCH_COMPLETED,
  ORDER_CREATE_COMPLETED,
  ORDER_UPDATE_COMPLETED,
  ORDER_REMOVE_COMPLETED,
  IRemoveOrderCompletedAction,
  ORDER_SUBMIT_COMPLETED,
  ISubmitOrderCompletedAction,
  ORDER_CANCEL_COMPLETED,
  ICancelOrderCompletedAction,
  ORDER_APPROVE_COMPLETED,
  IApproveOrderCompletedAction,
  ORDER_REJECT_COMPLETED,
  IRejectOrderCompletedAction, ORDER_RECALCULATE_COMPLETED, IRecalculateOrderCompletedAction
} from "../action-creators/orders";
import { TApiOrderDetails } from "../../api/endpoints/Order";

const initialItemState = {
  loading: false,
  loadedAt: null,
  error: null,
  data: null
};

export type TOrdersByIdState = {
  [id: string]: {
    loading: boolean;
    loadedAt: null | number;
    error: null | Error;
    data: TApiOrderDetails | null
  }
};

type TAllowedActions =
  ICreateOrderCompletedAction |
  IUpdateOrderCompletedAction |
  IMoveOrderRoFolderCompletedAction |
  IFetchOrderDetailsStartedAction |
  IFetchOrderDetailsCompletedAction |
  IFetchOrderDetailsFailedAction |
  ISubmitOrderCompletedAction |
  ICancelOrderCompletedAction |
  IApproveOrderCompletedAction |
  IRejectOrderCompletedAction |
  IRemoveOrderCompletedAction |
  IRecalculateOrderCompletedAction


const updateOrder = (state: TOrdersByIdState, order: TApiOrderDetails): TOrdersByIdState => {
  return {
    ...state,
    [order.id]: {
      ...state[order.id],
      data: order,
      loading: false,
      loadedAt: Date.now(),
      error: null
    }
  };
}

const removeOrder = (state: TOrdersByIdState, orderId: string | number): TOrdersByIdState => {
  return {
    ...state,
    [orderId]: { ...initialItemState }
  };
}


const ordersByIdReducer = (state: TOrdersByIdState = {}, action: TAllowedActions): TOrdersByIdState => {
  switch (action.type) {
    case ORDER_DETAILS_FETCH_STARTED: {
      const newItemState = state[action.id] || { ...initialItemState }
      const silentUpdate = action.options;

      return {
        ...state,
        [action.id]: { ...newItemState, loading: !silentUpdate }
      }
    }

    case ORDER_DETAILS_FETCH_COMPLETED: {
      return updateOrder(state, action.data);
    }

    case ORDER_CREATE_COMPLETED: {
      return updateOrder(state, action.order);
    }

    case ORDER_UPDATE_COMPLETED: {
      return updateOrder(state, action.order);
    }

    case ORDER_SUBMIT_COMPLETED: {
      return updateOrder(state, action.order);
    }

    case ORDER_CANCEL_COMPLETED: {
      return updateOrder(state, action.order);
    }

    case ORDER_APPROVE_COMPLETED: {
      return updateOrder(state, action.order);
    }

    case ORDER_REJECT_COMPLETED: {
      return updateOrder(state, action.order);
    }

    case ORDER_REMOVE_COMPLETED: {
      return removeOrder(state, action.orderId);
    }

    case ORDER_RECALCULATE_COMPLETED: {
      return updateOrder(state, action.order);
    }

    default:
      return state;
  }
}

export default ordersByIdReducer;
